import $ from 'jquery';


export default class Store {
  constructor(app) {
    this.app = app;
    this.init();
  }
  init(){
    this.getData();
    this.switchMap();
  }
  getData(){
    var stores_arr;
    var stores_xhr = new XMLHttpRequest();
    stores_xhr.open('get', this.app.host + 'api/stores', true);
    stores_xhr.send();
    stores_xhr.onload = function() {
      if (stores_xhr.status == 200) {
        stores_arr = JSON.parse(stores_xhr.responseText);
        // console.log(stores_arr);
        var obj = stores_arr.data;
        for(var x in obj){

          var zone=-1;
          switch(x){
            case "北部":
              // console.log('北部');
              zone =1;
            break;
            case "中部":
              // console.log('中部');
              zone =2;
            break;
            case "南部":
              // console.log('南部');
              zone =3;
            break;
            case "東部":
              // console.log('東部');
              zone =4;
            break;
          }
          // console.log(obj[x]);
          var gint=0;
          for(var y in obj[x]){
            gint++;
            // console.log(gint);
            // console.log(y);
            $('.sub'+zone+' .area__box').append(''+
              '<div class="accordion city__box" data-city="'+y+'" id="city__'+zone+'_'+gint+'">'+
                '<div class="card">'+
                  '<div class="card-header city__button" id="heading'+zone+'_'+gint+'">'+
                    '<h2 class="mb-0">'+
                      '<button class="btn btn-link" type="button" data-toggle="collapse" data-target="#city'+zone+'_'+gint+'" aria-expanded="true" aria-controls="city'+zone+'_'+gint+'">'+
                        y+
                      '</button>'+
                    '</h2>'+
                  '</div>'+
                  '<div id="city'+zone+'_'+gint+'" class="city__item collapse show" aria-labelledby="heading='+zone+'_'+gint+'" data-parent="#city__'+zone+'_'+gint+'">'+
                    '<div class="card-body">'+
                    '</div>'+
                  '</div>'+
                '</div>'+
              '</div>'
            )
            // console.log(obj[x][y]);
            for(var z=0;z<obj[x][y].length;z++){
              // console.log(obj[x][y][z]);
              $('#city'+zone+'_'+gint+' .card-body').append(''+
              '<div class="row st__item">'+
                '<div class="col-3">'+obj[x][y][z].name+'</div>'+
                '<div class="col-6">'+obj[x][y][z].address+'</div>'+
                '<div class="col-3">'+obj[x][y][z].phone+'</div>'+
              '</div>'
              )
            }
          }
        }
      }
    }.bind(this)
  }
  addStore(zone){
    console.log(zone);

    $('.sub'+zone+" .area__box").append();
  }
  switchMap(){
    // var subNum = parseInt(this.app.hash.replace("sub",""), 10);
    // console.log(subNum);
  }
  hashchange() {
    // this.switchMap();
    // console.log(this.app.hash)
  }
}
